var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['number-page']},[(_vm.isMobile)?_c('NumberPageMobile'):_c('NumberPageWeb')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }